import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { SettingsChangeSmartpayReaderPage } from 'src/app/modals/settings-change-smartpay-reader/settings-change-smartpay-reader.page';

const routes: Routes = [
  {
    path: '',
    component: SettingsChangeSmartpayReaderPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [SettingsChangeSmartpayReaderPage]
})
export class SettingsChangeSmartpayReaderPageModule {}
